// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

//vue-moment
Vue.use(require('vue-moment'));

Vue.use(BootstrapVue)

//toastr
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
 defaultPosition: 'toast-top-full-width',
 defaultType: 'info',
 defaultTimeout: 2000
});

//http HTTPPlugin
import HTTPPlugin from './views/util/http'
Vue.use(HTTPPlugin, router)

//fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);

//VUELİDATE
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
